module.exports = __webpack_public_path__ + "img/uon-icon.91e5e131.jpg";